export const DATA_HC_NAME_PAGE_AUTH_SPINNER = 'page-authorization-spinner';
export const HC_ORG_ID = 1;
export const SESSION_TIMEOUT_MINUTES = 30;
export const LOCAL_STORAGE_SESSION_ID = 'hcSessionId';
export const LOCAL_STORAGE_SESSION_TIME = 'hcSessionTime';
